import { ColumnsType } from 'antd/lib/table'
import formatNumber from '../../../../../helpers/formatters/format-any-number'
import { formatRollerDisplay } from '../../../../../helpers/format-roller-display'
import RewindQueueEntry from '../../../../../types/api/rewind-queue-entry'
import ShipmentPosition from '../../../../../types/api/shipment-position'
import { getShipmentFloods } from '../../helpers/get-shipment-floods'
import { MaterialColumnCell } from '../../../flexo/components/cells/material-column-cell'
import DragHandler from '../../../flexo/components/machines-queues/components/machine-queue/components/drag-handler'
import ActionsCell from './components/machine-queue/components/actions-cell'


export const columns: ColumnsType<RewindQueueEntry> = [
    { key: 'sort', align: 'center', width: 30, render: () => <DragHandler /> },
    {
        dataIndex: ['rewind_job', 'id'],
        title: '№',
        width: 60,
        render: value => value || '—',
    },
    {
        dataIndex: ['rewind_job', 'shipment', 'print_job', 'id'],
        title: 'Номер печати',
        width: 95,
        render: (_value, record) => record.rewind_job?.shipment?.print_job?.id || '—',
    },
    {
        dataIndex: ['rewind_job', 'shipment', 'id'],
        title: 'Номер отгрузки',
        width: 95,
        render: (_value, record) => record.rewind_job?.shipment?.id || '—',
    },
    {
        dataIndex: ['rewind_job', 'shipment', 'client', 'name'],
        title: 'Заказчик',
        render: (_value, record) => record.rewind_job?.shipment?.client?.name || '—',
    },
    {
        dataIndex: ['rewind_job', 'shipment', 'materialRequirements'],
        title: 'Материал',
        width: 110,
        render: (_value, record) => (
            <MaterialColumnCell value={record.rewind_job?.shipment?.materialRequirements || []} />
        ),
    },
    {
        dataIndex: ['rewind_job', 'shipment', 'bushing'],
        title: 'Втулка',
        width: 70,
        render: (_value, record) => record.rewind_job?.shipment?.bushing || '—',
    },
    {
        dataIndex: ['rewind_job', 'shipment', 'shipment_positions'],
        title: 'Ручьи',
        width: 70,
        render: (_value: ShipmentPosition[], record) => {
            const floods = getShipmentFloods(record.rewind_job?.shipment)

            return floods ?? '—'
        },
    },
    {
        dataIndex: ['rewind_job', 'shipment', 'roller', 'roller'],
        title: 'Вал',
        width: 100,
        render: (_value, record) => {
            const shipment = record.rewind_job?.shipment
            if (!shipment) return '—'

            const roller = shipment.withoutCutting
                ? shipment.virtualStamp?.roller?.roller
                : shipment.stamp?.roller?.roller

            return formatRollerDisplay(roller) ?? '—'
        },
    },
    {
        dataIndex: ['rewind_job', 'shipment', 'shipment_positions'],
        title: 'Тираж',
        width: 90,
        render: (_value, record) =>
            formatNumber(
                (record.rewind_job?.shipment?.shipment_positions || []).reduce(
                    (acc, position) => acc + (position.copies || 0),
                    0
                )
            ),
    },
    {
        dataIndex: 'actions',
        title: '',
        fixed: 'right',
        render: (_value, record) => <ActionsCell rewindQueueEntry={record} />,
    },
]
